import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
    .ec-dynamic-form-root, .ec-dynamic-form-root * {
        font-family: ${props => props.theme.fontFamily};
    }
`
